import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { navigationClient } from '../lib/navigation';
import { logger } from '../lib/logger';

export const useSection = () => {
  const location = useLocation();
  const { data: navigation } = useQuery({
    queryKey: ['navigation'],
    queryFn: () => navigationClient.getNavigation(),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000
  });

  // Special case for favorites section
  if (location.pathname.startsWith('/favoris')) {
    return {
      id: 'favorites',
      type_rubrique: 'favoris',
      names: {
        fr: 'Favoris',
        en: 'Favorites',
        es: 'Favoritos',
        it: 'Preferiti',
        pt: 'Favoritos',
        de: 'Favoriten',
        nl: 'Favorieten',
        ja: 'お気に入り',
        zh: '收藏夹',
        ru: 'Избранное'
      }
    };
  }

  // Get the section slug from the URL path
  const pathParts = location.pathname.split('/');
  const slug = pathParts[1]; // Now the slug is the first part of the path

  if (!navigation || !slug) {
    logger.warn('No navigation data or slug available', {
      category: 'Navigation',
      data: { path: location.pathname, slug }
    });
    return { type_rubrique: 'unknown', id: '', names: { fr: '' } };
  }

  // Find the section in navigation by slug only
  const section = navigation.find(item => {
    const itemSlug = navigationClient.generateSlug(item.names.fr);
    return itemSlug === slug;
  });

  if (!section) {
    logger.warn('Section not found in navigation', {
      category: 'Navigation',
      data: { path: location.pathname, slug }
    });
    return { type_rubrique: 'unknown', id: '', names: { fr: '' } };
  }

  return section;
};